import { List, ModelBase, NeoModel } from "@singularsystems/neo-core";
import FileExportStatusDTO from "./FileExportStatusDTO";
import FileImportProcessStatusModel from "./FileImportProcessStatusModel";
import ProcessingFileLookup from "./ProcessingFileLookup";
// Level 2
@NeoModel
export default class StaticServiceProviderImportStatusModel extends ModelBase {

    public serviceProviderGroupingName: string = "";

    public filesReceived: number | null = null;

    public filesImported: number | null = null;

    public rawImportLogID: number | null = null;

    public ignoresExchangeRatesInd: boolean = false;

    public fileImportProcessStatusModel = new List(FileImportProcessStatusModel);

    public fileExportStatus = new List(FileExportStatusDTO);

    public processingFiles = new List(ProcessingFileLookup);

    public allFileImportsPassInd: boolean = false;

    public wacStatus: string | null = null;
}